$(document).ready(function () {

    //Navigation Toolbar Service
    $.getScript('/ResourcePackages/Bootstrap4MI/assets/dist/js/Services/NavigationToolbarUIService.js', function () {
        let navigationToolbarUI = new NavigationToolbarUI();// eslint-disable-line no-undef
        navigationToolbarUI.toggleToolbar('#mi-corpo-floating-toolbar');
    });

    //Contact Form Response
    $.getScript('/ResourcePackages/Bootstrap4MI/assets/dist/js/Services/ContactFormResponseService.js', function () {
        let contactFormResponse = new ContactFormResponse();// eslint-disable-line no-undef
        contactFormResponse.showMessage();
    });
});
